import { Card, CardActionArea, CardContent, CardMedia, Typography } from "@mui/material";
import { API_URL } from "../../utils/lib";


/**
 * Product-list-element for 3Dfindit.
 * @param {*} param0 
 * @returns 
 */
export default function ProductListElement({ path, name, imagePath, catalogName, onClick = () => { } }) {
  return (
    <Card>
      <CardActionArea sx={{ minHeight: '100px' }} onClick={onClick} >
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'left',
          alignItems: 'center'
        }} >
          <div style={{
            width: '200px',
            height: '130px',
            minWidth: '200px'
          }}>
            <CardMedia
              component="img"
              sx={{ height: '100%', objectFit: 'contain' }}
              image={`${API_URL}/3dfindit/image?imagePath=${imagePath}`}
            />
          </div>
          <CardContent>
            <Typography gutterBottom variant="h6" component="div" >
              {name}
            </Typography>
            <Typography gutterBottom variant="h7" component="div" >
              {catalogName}
            </Typography>
          </CardContent>
        </div>
      </CardActionArea>
    </Card>
  )
};